module.exports = __webpack_public_path__ + "img/icon-onboarding-clipboard.e4ccb496.svg";